'use client';

import { faShare } from '@fortawesome/pro-light-svg-icons';
import { Professional } from '@medprev-web-app/api-graphql-client';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import { ReactNode } from 'react';

import { ShareButton } from '@/app/(main)/(pages)/(institucional)/_components/share-button.component';
import { entityActionStyle } from '@/app/(main)/(pages)/_components/entities/entity-action.styles';
import { EntityFavoriteButton } from '@/app/(main)/(pages)/_components/entities/entity-favorite-button.component';
import { Icon } from '@/components/ui/icon.component';
import { EntityTypeEnum } from '@/types/enums/entity-type.enum';

interface ProfessionalProfileActionsProps {
  professional: Professional;
  scheduleAction?: ReactNode;
}

export function ProfessionalProfileActions({
  professional,
  scheduleAction,
}: ProfessionalProfileActionsProps) {
  const favoriteEntityId = professional.id ? String(professional.id) : '';
  const showsFavoriteButton = Boolean(favoriteEntityId);

  const shareTrigger = (style: string, label?: string) => (openSheet: () => void) => (
    <button
      type="button"
      className={style}
      aria-label="Compartilhar perfil"
      data-testid={DataTestIdEnum.SHARED_ENTITY_CARD}
      onClick={openSheet}
    >
      <Icon icon={faShare} className="w-4 h-4 text-green-500" />
      {label}
    </button>
  );

  return (
    <div>
      <div
        className="hidden items-center gap-2 xl:grid xl:grid-cols-2"
        data-testid={DataTestIdEnum.PROFESSIONAL_PROFILE_ACTIONS_DESKTOP}
      >
        {showsFavoriteButton && (
          <EntityFavoriteButton
            entityId={favoriteEntityId}
            entityType={EntityTypeEnum.PROFESSIONAL}
            variant="labeled"
          />
        )}

        <ShareButton
          entityType={EntityTypeEnum.PROFESSIONAL}
          entity={professional}
          renderTrigger={shareTrigger(entityActionStyle({ variant: 'labeled', class: 'w-full' }), 'Compartilhar perfil')}
        />
      </div>

      <div className="flex items-center gap-2 xl:hidden" data-testid={DataTestIdEnum.PROFESSIONAL_PROFILE_ACTIONS_COMPACT}>
        {scheduleAction}

        {showsFavoriteButton && (
          <EntityFavoriteButton entityId={favoriteEntityId} entityType={EntityTypeEnum.PROFESSIONAL} />
        )}

        <div className="shrink-0">
          <ShareButton
            entityType={EntityTypeEnum.PROFESSIONAL}
            entity={professional}
            renderTrigger={shareTrigger(entityActionStyle({ variant: 'icon' }))}
          />
        </div>
      </div>
    </div>
  );
}
